import { render, staticRenderFns } from "./PrecificarPosto.vue?vue&type=template&id=6850386e&"
import script from "./PrecificarPosto.vue?vue&type=script&lang=js&"
export * from "./PrecificarPosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports